<app-shared-menu
  [menuItems]="menuItems()"
  [appVersion]="appVersion()"
  [isCollapsed]="isCollapsed()"
  currentApp="platform"
  (toggleSidebar)="onToggleSidebar()"
  dataCy="vertical-menu" />
